<template>
    <div class="store-selector mb-3">
        <div v-if="stores && stores.length">
            <div class="mb-1">
                <b>{{ title }}</b>
            </div>
            <b-dropdown
                ref="storesDropdownRef"
                :text="storeUrl"
                split
                variant="primary"
                @click="onStoresDropdownClick()"
            >
                <b-dropdown-item
                    v-for="store in filteredStores"
                    :key="store.Id"
                    :active="storeUrl == store.Url"
                    :value="store.Url"
                    @click="setStoreUrl(store.Url)"
                >
                    <div>{{ store.Url }}</div>
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div v-if="(!stores || !stores.length) && noStoresText">
            <div class="mb-1">
                <b>{{ noStoresText }}</b>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Store, StoreType } from '@/typings/user';
import { BDropdown } from 'bootstrap-vue';
import { Ref, computed, onBeforeMount, ref, watch } from 'vue';

const emit = defineEmits<{
    (event: 'input', value: string): void;
}>();

const props = withDefaults(
    defineProps<{
        title?: string;
        stores?: Store[];
        includeNoBilling?: boolean;
        noStoresText?: string;
        value?: string;
    }>(),
    {
        title: 'Switch stores to browse through your different subscriptions',
        stores: () => [],
        includeNoBilling: false,
        noStoresText: ''
    }
);

const storeUrl = ref('');
const storesDropdownRef: Ref<BDropdown | null> = ref(null);

const filteredStores = computed(() =>
    props.stores.filter((s) => (props.includeNoBilling ? true : s.HasBilling || s.Type === StoreType.Shopify))
);

watch(
    () => props.stores,
    () => {
        storeUrl.value = filteredStores.value.length ? filteredStores.value[0].Url : '';
    }
);

watch(
    () => props.value,
    () => {
        storeUrl.value = props.value || '';
    }
);

onBeforeMount(() => {
    if (filteredStores.value.length) {
        setStoreUrl(filteredStores.value[0].Url);
    }
});

const setStoreUrl = (store: string) => {
    if (storeUrl.value !== store) {
        storeUrl.value = store;
        emit('input', store);
    }
};

const onStoresDropdownClick = () => {
    storesDropdownRef.value?.show();
};
</script>

<style scoped>
.store-selector {
    font-size: 13px;
}
</style>
